import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState, memo } from 'react';
import { connect } from 'react-redux';

import Popups from '../../components/Popup';
import { saveBuyers } from '../../actions/company/companyTarget';
import config from '../../config';
import { saveInfo } from '../../actions/company/buyer/info';
import { usePopupContext } from '../../contexts/PopupContext';

const UpdateHighStatusPopupContainer = props => {
  const { closePopup } = usePopupContext();
  const { popup, userRole, saveBuyers, saveInfo } = props;

  const initialHighStatus = popup.getIn(['props', 'highStatus']);
  const currentStatus = popup.getIn(['props', 'currentStatus']);
  const statuses = popup.getIn(['props', 'statuses']);
  const companyId = popup.getIn(['props', 'companyId']);
  const buyerId = popup.getIn(['props', 'buyerId']);
  const type = popup.getIn(['props', 'type']);
  const directorEmail = popup.getIn(['props', 'directorEmail']);

  const shouldSendEmail = useMemo(
    () =>
      [config.ADMINISTRATOR, config.DIRECTOR].includes(userRole) ? false : popup.getIn(['props', 'isStatusExpired']),
    [userRole, popup],
  );

  const [highStatus, setHighStatus] = useState(initialHighStatus);
  const [correcting, setCorrecting] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(() => {
    closePopup();
  }, [closePopup]);

  const handleSave = useCallback(() => {
    if (shouldSendEmail) {
      const legacyHigh = statuses.find(s => s.get('value') === initialHighStatus);
      const currhigh = statuses.find(s => s.get('value') === highStatus);
      const body = `The High Status on this record is incorrect and should be changed from "${legacyHigh.get(
        'value',
      )}-${legacyHigh.get('name')}" to "${currhigh.get('value')}-${currhigh.get(
        'name',
      )}". The change took place more than 24 hours ago, and now needs Director approval for the change.\n\nLink to record: ${
        window.location.href
      }`;
      const subject = 'High Status mistakes';

      window.location = `mailto:${directorEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
        body,
      )}`;
    } else if (type === 'buyer') {
      setLoading(true);

      const body =
        Number(currentStatus) > Number(highStatus)
          ? {
              buyerHighStatus: highStatus,
              buyerCurrentStatus: highStatus,
            }
          : { buyerHighStatus: highStatus };

      saveInfo({
        companyId,
        body,
        afterSuccess: handleClose,
      });
    } else {
      const data = {
        companyId,
        id: buyerId,
        body: {
          highStatus,
        },
        afterSuccess: handleClose,
      };

      if (Number(currentStatus) > Number(highStatus)) {
        data.body.currentStatus = highStatus;
      }
      setLoading(true);
      saveBuyers(data);
    }
  }, [
    shouldSendEmail,
    statuses,
    initialHighStatus,
    highStatus,
    directorEmail,
    type,
    currentStatus,
    companyId,
    buyerId,
    saveInfo,
    saveBuyers,
    handleClose,
  ]);

  const handleChange = useCallback(({ target: { value, name, checked } }) => {
    if (name === 'correcting') {
      setCorrecting(checked);
    } else {
      setHighStatus(value);
    }
  }, []);

  return (
    <Popups.UpdateHighStatusPopup
      correcting={correcting}
      highStatus={highStatus}
      loading={loading}
      onChange={handleChange}
      onClose={handleClose}
      onSave={handleSave}
      shouldSendEmail={shouldSendEmail}
      statuses={statuses}
    />
  );
};

UpdateHighStatusPopupContainer.propTypes = {
  popup: PropTypes.object.isRequired,
  saveBuyers: PropTypes.func.isRequired,
  saveInfo: PropTypes.func.isRequired,
  userRole: PropTypes.string,
};

const mapStateToProps = state => ({
  userRole: state.auth.getIn(['user', 'roles', 0, 'slug']),
});

export { UpdateHighStatusPopupContainer };
export default connect(mapStateToProps, { saveBuyers, saveInfo })(memo(UpdateHighStatusPopupContainer));
